import "./ProjectsDialog.css";
import React, { useEffect} from 'react';
import { withTranslate } from 'react-redux-multilingual';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Input from '@mui/material/Input';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import MuiAlert from '@mui/material/Alert';

import {
    GetProjects,
    CreateNewProject,
    UpdateProject,
    DeleteProject,
} from '../../../services/Projects.service';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const innerHeight = window.innerHeight;

function ProjectsDialog(props) {

    const { translate, open, handleClose} = props;

    const [mode, setMode] = React.useState(1); // 1: List, 2: Add new, 3: Edit, 4 Delete
    const [searchProject, setSearchProject] = React.useState("");
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [pageCount, setPageCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [projects, setProjects] = React.useState([]);
    const [projectID, setProjectID] = React.useState();
    const [projectName, setProjectName] = React.useState();
    const [projectDescription, setProjectDescription] = React.useState();
    const [deleteConfirm, setDeleteConfirm] = React.useState("");
    const [alert, setAlert] = React.useState({ open: false, status: "", msg: "" });

    const onInit = () => {
        GetProjects(searchProject, rowsPerPage, page)
        .then(res => {
            // console.log(res)
            setPageCount(Math.ceil(res.data.datas[0][0]?.count / rowsPerPage));
            setProjects(res.data.datas[1]);
        })
        .catch(err => console.log(err));
    }

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(event.target.value);
    };

    const handleChangePage = (event, value) => {
        setPage(parseInt(value) - 1);
    };

    const onClickAddNew = () => {
        setProjectName("");
        setProjectDescription("");
        setMode(2);
    }

    const onSubmitAddNew = () => {
        if(projectName) {
            CreateNewProject({ projectName, projectDescription })
            .then(res => {
                // console.log(res);
                setAlert({ open: true, status: res.data.status, msg: translate(res.data.msg) });
                setTimeout(() => {
                    onClickBack();
                    onInit();
                }, 1000)
            })
            .catch(err => {
                setAlert({ open: true, status: err.response.data.status, msg: translate(err.response.data.msg) });
            });
        }
    }

    const onClickEdit = (ID) => {
        if(ID) {
            let project = projects.find(project => project.ID === ID);
            setProjectID(ID);
            if(project.name) {
                setProjectName(project.name);
                setProjectDescription(project.description);
                setMode(3);
            }
        }
    }

    const onSubmitEdit = () => {
        if(projectName) {
            UpdateProject({ projectID, projectName, projectDescription })
            .then(res => {
                // console.log(res);
                setAlert({ open: true, status: res.data.status, msg: translate(res.data.msg) });
                setTimeout(() => {
                    onClickBack();
                    onInit();
                }, 1000)
            })
            .catch(err => {
                setAlert({ open: true, status: err.response.data.status, msg: translate(err.response.data.msg) });
            });
        }
    }

    const onClickDelete = (ID) => {
        if(ID) {
            let project = projects.find(project => project.ID === ID);
            setProjectID(ID);
            if(project.name) {
                setProjectName(project.name);
                setDeleteConfirm("");
                setMode(4);
            }
        }
    }

    const onSubmitDelete = () => {
        if(projectID) {
            DeleteProject(projectID)
            .then(res => {
                // console.log(res);
                setAlert({ open: true, status: res.data.status, msg: translate(res.data.msg) });
                setTimeout(() => {
                    onClickBack();
                    onInit();
                }, 1000)
            })
            .catch(err => {
                setAlert({ open: true, status: err.response.data.status, msg: translate(err.response.data.msg) });
            });
        }
    }

    const onClickBack = () => {
        setMode(1);
        setAlert({ open: false, status: "", msg: "" })
    }

    useEffect(() => {
        onInit();
    }, [searchProject, rowsPerPage, page])

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', boxShadow: 'none' }} color="info">
            <Toolbar>
                <CreateNewFolderOutlinedIcon />
                <Typography sx={{ ml: 1, flex: 1, textAlign: "left" }} variant="h6" component="div">
                {translate('projects')}
                </Typography>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            </AppBar>
            <Box sx={{ p: 2 }}>
                {mode === 1 &&
                <Box>
                    <Box sx={{ 
                            p: 1, 
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: '1px solid rgb(229, 234, 242)'
                        }}
                    >
                        <Box className='search-box'>
                            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
                                <SearchIcon />
                            </IconButton>
                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder={translate('search')}
                                defaultValue={searchProject}
                                onChange={(e) => setSearchProject(e.target.value)}
                            />
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Box>
                                <Button variant="contained" disableElevation onClick={onClickAddNew}>{translate('addnew')}</Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ height: (innerHeight - 64 - 62 - 16 - 32 - 49) }}>
                        <Table sx={{ marginY: 2 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell align="left">{translate('projectname')}</TableCell>
                                    <TableCell align="left">{translate('description')}</TableCell>
                                    <TableCell align="center">{translate('users')}</TableCell>
                                    <TableCell align="center">{translate('robots')}</TableCell>
                                    <TableCell align="left">{translate('createddate')}</TableCell>
                                    <TableCell align="left">{translate('createduser')}</TableCell>
                                    <TableCell align="center">{translate('action')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {projects.map((project, index) => (
                                <TableRow
                                    key={project.ID}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell scope="row">{index + 1}</TableCell>
                                    <TableCell align="left">{project.name}</TableCell>
                                    <TableCell align="left">{project.description}</TableCell>
                                    <TableCell align="center">
                                        <PersonOutlineIcon />
                                        {project.users}
                                    </TableCell>
                                    <TableCell align="center">
                                        <PrecisionManufacturingIcon/>
                                        {project.robots}
                                        </TableCell>
                                    <TableCell align="left">{project.createdDate}</TableCell>
                                    <TableCell align="left">{project.createdUser}</TableCell>
                                    <TableCell align="center">
                                        <IconButton color="error" size="small" onClick={() => onClickDelete(project.ID)}>
                                            <DeleteOutlineIcon />
                                        </IconButton>
                                        <IconButton color="secondary" size="small" onClick={() => onClickEdit(project.ID)}>
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </Box>
                    <Box display="flex" justifyContent="space-between" p={1}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <span>{translate('rowsperpage')}:</span>
                            <FormControl sx={{ mr: 1 }} size="small">
                                <Select
                                    value={rowsPerPage}
                                    onChange={handleChangeRowsPerPage}
                                    displayEmpty
                                    autoWidth
                                    sx={{ "& > div": { padding: "5px 10px" }, "& > fieldset": { borderColor: "rgb(229, 234, 242)" } }}
                                >
                                    {[50, 100, 200].map(item => (
                                        <MenuItem value={item}>{item}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Pagination 
                            shape="rounded" 
                            count={pageCount}
                            page={page + 1}
                            onChange={handleChangePage}
                            color="primary" 
                        />
                    </Box>
                </Box>}
                {(mode === 2 || mode === 3 || mode === 4) &&
                <Box>
                    <Box sx={{ display: "flex", justifyContent: "left", mb: 4 }}>
                        <IconButton size="small" sx={{ mr: 2 }} onClick={onClickBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="span" component="div" sx={{ lineHeight: "34px" }}>{translate('back')}</Typography>
                    </Box>
                    {(mode === 2 || mode === 3) &&
                    <Box>
                        <Box className="input-group">
                            {alert.open && <Alert severity={alert.status}>{alert.msg}</Alert>}
                            <Box py={2}>
                                <FormControl fullWidth>
                                    <label>{translate('projectname')}&nbsp;*</label>
                                    <Input
                                        placeholder={translate('projectnameexample')}
                                        defaultValue={projectName}
                                        onChange={(e) => setProjectName(e.target.value)}
                                    />
                                </FormControl>
                            </Box>
                            <Box py={2}>
                                <FormControl fullWidth>
                                    <label>{translate('description')}</label>
                                    <TextareaAutosize
                                        minRows={5}
                                        placeholder={translate('descriptionexample')}
                                        style={{ marginTop: 20, maxHeight: 200, maxWidth: "100%" }}
                                        defaultValue={projectDescription}
                                        onChange={(e) => setProjectDescription(e.target.value)}
                                    />
                                </FormControl>
                            </Box>
                        </Box>
                        <Box className="action-group">
                            <Button variant="text" onClick={onClickBack}>{translate('cancel')}</Button>
                            {mode === 2 && <Button variant="contained" disabled={!projectName} onClick={onSubmitAddNew}>{translate('addnew')}</Button>}
                            {mode === 3 && <Button variant="contained" disabled={!projectName} onClick={onSubmitEdit}>{translate('save')}</Button>}
                        </Box>    
                    </Box>}
                    {mode === 4 && 
                    <Box>
                        <Box className="input-group">
                            {alert.open && <Alert severity={alert.status}>{alert.msg}</Alert>}
                            <Box py={2}>
                                <Typography variant="h5" gutterBottom>
                                    {translate('deleteprojectconfirm', { projectName: projectName })}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {translate('deleteprojectsubtitle')}
                                </Typography>
                            </Box>
                            <Box py={2}>
                                <FormControl fullWidth>
                                    <Input
                                        placeholder={translate('delete')?.toLowerCase()}
                                        onChange={(e) => setDeleteConfirm(e.target.value)}
                                    />
                                </FormControl>
                            </Box>
                        </Box>
                        <Box className="action-group">
                            <Button variant="text" onClick={onClickBack}>{translate('cancel')}</Button>
                            <Button variant="contained" color="error" disabled={deleteConfirm !== translate('delete')?.toLowerCase()} onClick={onSubmitDelete}>{translate('delete')}</Button>
                        </Box> 
                    </Box>}
                </Box>}
            </Box>
        </Dialog>
    );
}

export default withTranslate(ProjectsDialog)